export default function getIdYoutube(url: string) {
  const videoId = url.split("=")[1]?.split("&").shift();
  return videoId;
}
